<template>
  <header class="header" :style="mainColor">
    <!-- <div style="position: absolute" v-if="isMobile">Моб.</div> -->
    <nav class="container">
      <ul class="header__col" :class="theme ? 'upperday' : 'uppernight'">
        <li class="upper">
          <div class="upper__home" @click="setSelectedComponent('the-shedule')">
            <img
              src="@/assets/images/back.svg"
              alt="home"
              width="35"
              height="31"
            />
          </div>
          <div class="upper__lang">
            <toggle-btn @setIsActive="toggleLang"></toggle-btn>
          </div>
          <div class="flatpickr upper__today" v-show="isTodayNum">
            <div id="attach" data-toggle class="upper__wrapday" @click="togCal">
              <img
                src="@/assets/images/today.svg"
                alt="today"
                width="35"
                height="35"
              />
              <div class="upper__wrapday_ce" :class="txtDN">
                {{ currDay }}
              </div>
            </div>
            <div
              class="upper__clearday"
              :class="txtDN"
              style="font-size: 2rem"
              data-clear
              @click="receiveDate(0)"
            >
              &#x21BA;
            </div>
          </div>
          <flat-pickr
            style="display: none"
            v-model="date"
            :config="config"
          ></flat-pickr>
          <div
            v-show="isMobile"
            class="upper__bars"
            @click="goTo"
            :class="toggleSide ? 'rotate' : 'arotate'"
          >
            <span :class="humb"></span>
            <span :class="humb"></span>
            <span :class="humb"></span>
          </div>
        </li>
        <li class="lower" :class="theme ? 'lowerDay' : 'lowerNight'">
          <div
            v-show="!isMobile"
            class="lower__info"
            @click="setSelectedComponent('the-info')"
          >
            <img
              src="@/assets/images/info.svg"
              alt="info"
              width="35"
              height="32"
            />
          </div>
          <div class="lower__fulldate" :class="theme ? 'dateDay' : 'dateNight'">
            <div
              v-if="isTodayNum && !date"
              class="arrow-before"
              @click="receiveDate(-1)"
            >
              <img
                src="@/assets/images/arrow_left.svg"
                alt="arrow-left"
                width="28"
                height="28"
              />
            </div>
            <!-- <div class="nowdate">{{ day }} {{ month }} ({{ weekDay }})</div> -->
            <div class="nowdate" :class="txtDN" @click="defineTheme">
              {{ nowAday }}
            </div>
            <div
              v-if="isTodayNum && !date"
              class="arrow-after"
              @click="receiveDate(1)"
            >
              <img
                src="@/assets/images/arrow_right.svg"
                alt="arrow-right"
                width="28"
                height="28"
              />
            </div>
          </div>
          <div
            v-show="!isMobile"
            class="lower__graph"
            @click="setSelectedComponent('the-graph')"
          >
            <img
              src="@/assets/images/chart.svg"
              alt="chart"
              width="35"
              height="31"
            />
          </div>
        </li>
        <!-- <li style="position: absolute; top: 8.2rem">{{ nowAday }}</li> -->
      </ul>
    </nav>
  </header>
  <aside v-show="isMobile" class="sidenav" :class="addAct">
    <div
      class="sidenav__block"
      :class="theme ? 'sidenav_day' : 'sidenav_night'"
    >
      <div @click="goTo" class="sidenav__block-close">
        <svg
          :style="theme ? 'fill: black' : 'fill: #F8F8FF'"
          width="30"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.006.006C1.453-.036.916.134.526.526c-.783.782-.68 2.145.232 3.056L12.176 15 .758 26.418c-.911.911-1.015 2.274-.233 3.057.783.782 2.146.678 3.057-.233L15 17.824l11.418 11.418c.911.911 2.274 1.015 3.057.233.782-.783.678-2.146-.233-3.057L17.824 15 29.242 3.582c.911-.911 1.015-2.274.233-3.057-.783-.782-2.146-.678-3.057.233L15 12.176 3.582.758A2.524 2.524 0 0 0 2.006.006z"
          />
        </svg>
      </div>
      <nav>
        <ul>
          <li class="mobinfo" @click="setSelectedComponent('the-info', 1)">
            <!-- <div > -->
            <img
              src="@/assets/images/info.svg"
              alt="info"
              width="48"
              height="42"
            />
            <!-- </div> -->
          </li>
          <li class="mobgraph" @click="setSelectedComponent('the-graph', 2)">
            <img
              src="@/assets/images/chart.svg"
              alt="chart"
              width="48"
              height="42"
            />
          </li>
        </ul>
      </nav>
    </div>
    <div @click="goTo" class="sidenav__overlay"></div>
  </aside>

  <component :is="selectedComponent" v-bind="currentProps" @toReading="toRead">
  </component>

  <transition name="upd">
    <template v-if="updateExists">
      <div class="update-popup">
        Новое обновление доступно
        <br />
        <button @click="refreshApp">Обновить</button>
      </div>
    </template>
  </transition>
</template>

<script>
import update from './mixins/update.js'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/themes/dark.css'
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import ToggleBtn from './components/ui/ToggleBtn.vue'
import TheShedule from './components/TheShedule.vue'
import TheGraph from './components/TheGraph.vue'
import TheReading from './components/TheReading.vue'
import TheInfo from './components/TheInfo.vue'

export default {
  name: 'App',
  components: {
    TheShedule,
    TheGraph,
    TheReading,
    TheInfo,
    ToggleBtn,
    flatPickr
  },
  data() {
    return {
      date: null,
      theme: null, // true, if установлена на день
      selectedComponent: 'the-shedule',
      currentReading: null,
      isMobile: null,
      windowWidth: null,
      toggleSide: false,
      isTodayNum: true,
      dateValue: 0,
      month: '',
      currDay: 0,
      day: 0,
      weekDay: '',
      dataToParse: '',
      lang: true,
      isLitera: ['', ''],
      config: {
        mode: 'single',
        wrap: true,
        dateFormat: 'Y-m-d-l',
        clickOpens: true,
        position: 'auto center',
        locale: Russian,
        minDate: '2025-01',
        maxDate: '2026-02',
        enable: [{ from: '2025-01-14', to: '2026-01-13' }]
      },
      parse: [
        {
          Утреня: [{ boo: 'Лк.', z: ['24 зач.', 'VI, 17–23.'] }]
        },
        {
          ['Литургия']: [
            { boo: 'Деян.', z: ['24 зач.', 'X, 1–16.'] },
            { boo: 'Ин.', z: ['24 зач.', 'VI, 56–69.'] },
            { boo: 'Прп.: Евр.', z: ['334 зач.', 'XIII, 7–16.'] },
            { boo: 'Мф.', z: ['43 зач.', 'XI, 27–30.'] }
          ]
        }
      ],
      nameOfMonth: [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря'
      ]
    }
  },
  mixins: [update],
  created() {
    let t = JSON.parse(localStorage.getItem('theme'))
    if (t === null) {
      localStorage.setItem('theme', true)
      this.theme = true
    } else {
      this.theme = t
    }

    window.addEventListener('resize', this.checkScreen)
    this.checkScreen()
    // let m = 1
    // let timerId = setInterval(() => {
    //   console.log(m)
    //   this.receiveDate(0, m)
    //   m++
    // }, 2000)
    // setTimeout(() => {
    //   clearInterval(timerId)
    //   alert('stop')
    // }, 61000)
    this.receiveDate(0)
    // this.parse = this.pickupParse()
  },
  methods: {
    defineTheme() {
      this.theme = !this.theme
      localStorage.setItem('theme', this.theme)
    },
    checkScreen() {
      this.windowWidth = window.innerWidth
      if (this.windowWidth <= 750) {
        this.isMobile = true
      } else this.isMobile = false
    },
    goTo() {
      this.toggleSide = !this.toggleSide
    },
    toggleLang(isActive) {
      this.lang = isActive
    },
    togCal() {
      this.config.positionElement = document.getElementById('attach')
    },
    // передаем всю книгу, а не по-отдельности части
    toRead(b) {
      this.isTodayNum = false
      this.selectedComponent = 'the-reading'
      // передаем целую книгу
      this.currentReading = { book: b, l: this.lang, t: this.theme }
    },
    setSelectedComponent(comp, p) {
      // если мобильная, то выключаем боковое меню
      if (this.isMobile && (p === 2 || p === 1)) {
        this.toggleSide = !this.toggleSide
      }
      if (comp === 'the-shedule') this.isTodayNum = true
      this.selectedComponent = comp
      // this.currentReading = toRead
    },
    receiveDate(diff) {
      let now = new Date()
      // let now = new Date(2023, 0, 12)

      this.currDay = now.getDate()

      if (diff === 1 && this.dateValue < 7) {
        this.dateValue++
        now.setDate(now.getDate() + this.dateValue)
      } else if (diff === -1 && this.dateValue > -7) {
        this.dateValue--
        now.setDate(now.getDate() + this.dateValue)
      } else {
        this.dateValue = 0
        this.date = null
      }
      let mIndex = now.getMonth()
      const days = ['вс.', 'пн.', 'вт.', 'ср.', 'чт.', 'пт.', 'сб.']
      this.month = this.nameOfMonth[mIndex]
      this.day = now.getDate()
      this.weekDay = days[now.getDay()]
      this.showParse(mIndex, this.day)
    },
    showParse(mInde, da) {
      this.dataToParse = this.$store.state.calendar[mInde][mInde][da - 1]
      // this.dataToParse = 'можно подставить строку из календаря любую'
      // this.reading = this.dataToParse // исправить, если будет компонента
      if (mInde === 3 && da === 18) {
        this.parse = this.$store.state.vp
        this.isLitera = ''
      } else this.parse = this.pickupParse(this.dataToParse)
    },
    pickupParse(str) {
      // let a = []
      let lt = str[str.length - 1]
      let pr = str.match(/(?<=\.).{2}$/g)
      if (pr) {
        this.isLitera = this.$store.state.prazd[pr[0]]
      } else if (!pr && lt === 'Н') {
        this.isLitera = ['Литургии не положено', 'Літургjи не пол0жено']
      } else if (!pr && lt === 'В') {
        this.isLitera = [
          'Литургия свт. Василия Великого',
          'Літургjа ст7лz васjліа вели1кагw'
        ]
      } else if (!pr && lt === 'П') {
        this.isLitera = [
          'Литургия Преждеосвященных Даров',
          'Літургjа преждеwсщ7є1нныхъ дарHвъ'
        ]
      } else this.isLitera = ['', '']

      // учесть пустой символ в конце каждой службы
      let array = [
        ['На веч. – Благовещения:', 'На веч. Благовещения'],
        ['На 9-м часе:', 'На 9-м часе'],
        ['На веч.:', 'На вечерне'],
        ['Утр. –', 'Утреня'],
        ['На 1-м часе:', 'На 1-м часе'],
        ['На 3-м часе:', 'На 3-м часе'],
        ['На 6-м часе:', 'На 6-м часе'],
        ['Лит. –', 'Литургия']
      ]
      let actualServ = []
      for (let el of array) {
        let matchAl = [...str.matchAll(new RegExp(el[0], 'g'))]
        if (matchAl.length) {
          // сразу заменили на полное название службы
          matchAl[0][0] = el[1]
          // записываем (вместо) длину аббр. службы, кот. будет use
          matchAl[0]['groups'] = el[0].length
          actualServ.push(matchAl[0])
        }
      }

      // array.forEach((el) => {})
      // если не обнаружены упоминания служб
      // отправляем все в Литургию
      let serv = []
      if (!actualServ.length) {
        let tempLiturg = {}
        tempLiturg[''] = this.filterBook(str)
        serv.push(tempLiturg)
        return serv
      }
      // форматируем к виду { 0: ['Утр. -', idx, length], 1: ['Лит. -', idx, length]}
      let sortServ = actualServ.sort((prev, next) => prev.index - next.index)
      // console.log(sortServ)
      serv = sortServ.reduce((acc, service, ix) => {
        // стартовый индекс вырезки, база - первая буква аббр. службы в исх. строке
        // позиция аббр. + его длина + один пробел
        let startIx = service.index + sortServ[ix]['groups'] + 1
        // конечный индекс вырезки, как начало следующего куска минус 1
        let endIx = 0
        if (sortServ[ix + 1]) {
          endIx = sortServ[ix + 1].index - 1
        } else {
          endIx = str.length
        }
        let pie = str.slice(startIx, endIx)
        let obj = {}
        obj[service[0]] = this.filterBook(pie)
        acc.push(obj)
        return acc
      }, [])
      return serv
    },
    filterBook(strOfService) {
      let arrBook = this.$store.state.arrBook
      let books = []
      let startIndex = 0 // начальный индекс для куска, содержащего в конце ':'
      let arrBooks = []
      for (let b of arrBook) {
        let r
        if (b === 'Ин.') {
          r = new RegExp(/(?<=\s)Ин.|^Ин./, 'g')
        } else r = new RegExp(b, 'g')
        // let matchAl = [...strOfService.matchAll(new RegExp(b, 'g'))]
        let matchAl = [...strOfService.matchAll(r)]
        if (matchAl.length) {
          // собираем все книги в один сложный массив, в том числе, если есть дубликаты книг
          arrBooks.push(matchAl)
        }
      }
      // собрали массив с книгами и их индексами
      books = arrBooks
        .reduce((acc, m) => {
          let obj = {}
          for (let elem of m) {
            obj['boo'] = elem[0]
            obj['idx'] = elem.index
            acc.push(obj)
            obj = {}
          }
          // m.forEach((elem) => {})
          return acc
        }, [])
        .sort((prev, next) => prev.idx - next.idx)
      // console.log(books)
      // улавливаем зачала (первое, второе, от полу, или само) и стихи, если зачал нет, то ['']
      let zs = strOfService.match(/\d{1,}\sзач\..*?,/g) || ['']
      let ch = strOfService.match(/[A-Z]{1,}.*?\./g)
      // добавляем добавки
      // let addition = strOfService.match(/.+:\s(?=)|Ев.\s\d+-е,\s/g)
      books.map((b, i, books) => {
        let bb = b['boo'] // сохраняем значение старого ключа
        // кусок, в котором содержится ' : '
        let piece = ''
        // кусочек, который может быть добавлен к значению старого ключа
        let additionalPiece = ''
        piece = strOfService.slice(startIndex, b.idx)
        if (piece.includes(':') || strOfService.includes('Ев. сост')) {
          // находим блок в piece, который заканчивается цифрой
          // let part = piece.match(/.*(\d)/gm) || ['0']
          let part = piece.match(/^(?!Недели).*\d/gm) || ['0']
          // находим позицию последней цифры
          let posLastDigit = part[0].length
          // вырезаем часть, которую нужно приставить к bb (начиная с + 2, т. к. до нее м. б. ". " или ", ")
          // если цифры нет, то значит добавка находится в самом начале
          if (part[0].length > 1) {
            additionalPiece = piece.slice(posLastDigit + 2, piece.length)
          } else additionalPiece = piece
        } else if (strOfService.includes('Ев. ')) {
          additionalPiece = strOfService.match(
            /(Ев\.)(\s|.)\d{1,}(-е,(\s|.))/g
          )[0]
        }
        // console.log(bb)

        b['boo'] = additionalPiece + bb
        if (zs.length) {
          let undf = zs[i] || '' // i может быть несколько, а zs.length = 1, чтобы не было undf
          b['z'] = [undf, ch[i]]
        } else {
          b['z'] = [ch[i]]
        }

        startIndex = books[i].idx
        delete b['idx']
      })
      // console.log(books)
      return books
    },
    getNowday(date) {
      let parse = date.match(/(?!0)(?:\d{1,}|(?:[А-я].+))/g)
      let m = parse[1]
      let d = parse[2]
      let dw = parse[3].match(/([ПВСЧП])?[^оеяу]/g).join('')
      this.showParse(+m - 1, +d)
      return `${d} ${this.nameOfMonth[+m - 1]} (${dw
        .slice(0, 2)
        .toLowerCase()}.)`
    }
  },
  computed: {
    txtDN() {
      return {
        txtDay: this.theme,
        txtNight: !this.theme
      }
    },
    mainColor() {
      return this.theme
        ? (document.querySelector('#app').style.backgroundColor = '#DCDCDC')
        : (document.querySelector('#app').style.backgroundColor = 'dimgrey')
    },
    humb() {
      return this.theme ? 'span_day' : 'span_night'
    },
    nowAday() {
      return this.date
        ? this.getNowday(this.date)
        : +this.day + ' ' + this.month + ' (' + this.weekDay + ')'
    },
    addAct() {
      return this.toggleSide ? 'active' : ''
    },
    currentProps() {
      let propers = null
      if (this.selectedComponent === 'the-graph') {
        propers = { isDay: this.theme }
      } else if (this.selectedComponent === 'the-info') {
        propers = { note: 'Справка', isDay: this.theme }
      } else if (this.selectedComponent === 'the-reading') {
        // уже кликнули на зачало и передаем всю книгу
        propers = this.currentReading
      } else if (this.selectedComponent === 'the-shedule') {
        propers = {
          isLitera: this.lang ? this.isLitera[1] : this.isLitera[0],
          parse: this.parse,
          isDay: this.theme
        }
      }
      return { msg: propers }
    }
  },
  watch: {
    lang() {
      if (this.currentReading) {
        this.currentReading.l = this.lang
      }
    },
    theme() {
      if (this.currentReading) {
        this.currentReading.t = this.theme
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/sass/app.scss';

html {
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // height: 100%;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  // background-color: #fffacd; // можно замостить картинкой
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

section {
  flex: 1; // Это чтобы секция растягивалась, а также видимо она расширяется, так как в классе shedule
  // margin-top: 8rem; // когда __col добавили fixed
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: initial;

  margin: 0 auto;
  // width: 750px; // возможно нужно править для media
  max-width: 850px;
  &_sec {
    width: 100%;
    padding: 1rem 0.75rem;
    // margin-bottom: 3rem; // это только для крупных экранов?
    // box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.5);
  }
}

.upperday {
  background-color: #ecbc5a; // #f9a825
}
.uppernight {
  background-color: #262a2d;
}

.lowerDay {
  background-color: #adae62; // #aeb05d
}
.lowerNight {
  background-color: black;
}

.dateDay {
  background-color: #c9c76b; // #cbc865
}
.dateNight {
  background-color: #282a35;
}

.fonday {
  // background-color: #e4dcd1;
  background: url('@/assets/images/bg.gif');
}
.fonnight {
  background-color: #1b1f23;
}

.txtDay {
  color: #282a35;
}
.txtNight {
  color: #dcdcdc;
}

.span_day {
  background-color: #151812;
}
.span_night {
  background-color: #f8f8ff;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.header {
  height: 8rem;
  flex: 0; // шапка прижимается секцией

  &__col {
    // position: fixed; // для скрывания шапки
    // top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 8rem;
  }
  .upper {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    justify-content: space-around;

    &__home {
      img {
        width: 2.2rem;
        height: auto;
        cursor: pointer;
      }
    }

    &__today {
      // position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
      cursor: pointer;
    }
    &__wrapday {
      position: relative;
      img {
        width: 2.2rem;
        height: auto;
        cursor: pointer;
      }
      &_ce {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -35%);
      }
    }

    &__bars {
      height: 2rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
      cursor: pointer;
      span {
        display: block;
        width: 2.2rem;
        height: 0.25rem;
      }
    }
  }
  .lower {
    display: flex;
    width: 100%;
    // font-size: 1.7rem;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    border-radius: 16px 16px 0 0;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.5);

    &__info {
      width: 1.8rem;
      height: auto;
      cursor: pointer;
    }

    &__fulldate {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 0 1rem;
      border-radius: 2rem;
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.5);

      .arrow-before,
      .arrow-after {
        width: 1.8rem;
        cursor: pointer;
      }

      .nowdate {
        margin: 0 1rem;
        width: 14.25rem;
        font-size: 1.75rem;
        text-align: center;
        cursor: pointer;
      }
    }

    &__graph {
      width: 1.8rem;
      height: auto;
      cursor: pointer;
    }
  }
}

.rotate {
  transition: 0.7s all ease;
  transform: rotate(180deg);
}
.arotate {
  transition: 0.7s all ease;
  transform: rotate(0deg);
}

.sidenav {
  position: fixed;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100vh;
  z-index: 100;
  visibility: hidden;
  opacity: 0;
  transition: all 0.6s;
  &.active {
    left: 0;
    visibility: visible;
    opacity: 1;
  }
  &__block {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    width: 10rem;
    height: 100%;
    overflow-y: auto;
    padding-top: 4.5rem;
    // padding-left: 2.5rem;
    transition: all 0.6s;
    z-index: 10;
    &-close {
      position: absolute;
      top: 1.6rem;
      right: 1.6rem;
      cursor: pointer;
    }

    .mobinfo,
    .mobgraph {
      margin: 2rem 0;
      img {
        display: block;
        margin: 0 auto;
        width: 3rem;
        cursor: pointer;
      }
    }
  }
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.5;
  }
}

.sidenav_day {
  background-color: #e4dcd1;
}
.sidenav_night {
  background-color: #262a2d;
  border-right: solid black 2px;
}

.update-popup {
  position: fixed;
  right: 1em;
  bottom: 1em;
  padding: 1em;
  border: 1px solid #3eaf7c;
  border-radius: 3px;
  background: #fff;
  box-shadow: 0 4px 16px rgb(0 0 0 / 50%);
  text-align: center;
  z-index: 2;
}
.update-popup > button {
  margin-top: 0.5em;
  padding: 0.25em 2em;
  border-radius: 3px;
  border: 1px solid lightblue;
}
.update-popup > button:hover {
  background-color: lightgreen;
}
.update-popup > button:focus {
  outline: none;
}

.upd-leave-active {
  animation: modall 0.4s ease-in reverse;
}

@keyframes modall {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

// все, что выше - это для экранов вплоть до 575px, если не изменено в нижних правилах

@media screen and (min-width: 576px) {
}

@media screen and (min-width: 767px) {
  .container {
    &_sec {
      margin-bottom: 2rem;
      padding: 1rem 1.5rem;
      box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.5);
    }
  }
  .header {
    .lower {
      &__info {
        width: 2.2rem;
      }
      &__graph {
        width: 2.2rem;
      }
    }
  }
}

@media screen and (min-width: 991px) {
  .header {
    .lower {
      &__fulldate {
        .nowdate {
          font-size: 1.9rem;
          width: 16rem;
        }
      }
    }
  }
}

// как только мы достигаем min 1200px (увеличивая экран) и больше
@media screen and (min-width: 1200px) {
}
</style>
